import React from 'react'
import Navbars from '../Navbars'
import Sidebar from '../profile/Sidebar'
import one from "../assets/one.png"
import two from "../assets/two.png"
import three from "../assets/three.png"
import four from "../assets/four.png"
import plus from "../assets/plus.png"
import { socialicons } from '../posting/Socialarray'
import { analyticarray } from '../posting/Socialarray'
import "./analytics.css"
import fb from "../assets/fb.png"
import down from "../assets/down.png"
import chart from "../assets/chart.png"
function Analytics() {
    return (<>
        <div className='conatiner-fluid' style={{ backgroundColor: "#F5F5F5" }}>
            <Navbars />
            <div className='d-flex gap-5 pe-3 main_div'>
                <Sidebar />
                <div className='inner_div ps-3 pe-3 mb-5 pb-5' style={{ backgroundColor: "white",marginTop:"85px" }}>
                    <div className='row'>
                        <div className='col-lg-3 col-md-6 col-sm-12'>
                            <p className='post_heading' style={{ textAlign: "center", paddingTop: "10px",marginTop:"0px",marginBottom:"-5px" }}>Platforms</p>
                            <div className='post_div'>
                                {
                                    socialicons.map((item) => {
                                        return (<>
                                            <div className='d-flex gap-2 align-items-center mt-2 pb-2'>
                                                <img className='img_map' src={item.img} />
                                                <p className='text_map'>{item.text}</p>
                                            </div>
                                        </>)
                                    })
                                }
                            </div>
                            <div className='create_post_div'>
                                <p className='post_heading ' style={{ textAlign: "center", paddingTop: "20px" }}>My Accounts</p>
                                <div className='user_social'>
                                    <img src={one} />
                                    <p className='user_name1'>Adam Person</p>

                                </div>
                                <div className='user_social'>
                                    <img src={two} />
                                    <p className='user_name1'>Adam Person</p>
                                </div>
                                <div className='user_social'>
                                    <img src={three} />
                                    <p className='user_name1'>Adam Person</p>
                                </div>
                                <div className='user_social'>
                                    <img src={four} />
                                    <p className='user_name1'>Adam Person</p>

                                </div>
                                <div className='button_div'>

                                    <button className='Add_Account' >
                                        <div className='d-flex align-items-center gap-2 flex-wrap justify-content-center'>
                                            <img src={plus} />
                                            <p className='account_text'>Add Account</p>
                                        </div>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-md-6 col-sm-12 analytics_main pt-4'>
                            <div className='sec_div mt-2'>
                                <p className='total1'>Total Posts</p>
                                <p className='total2'>500k</p>

                            </div>
                            {
                                analyticarray.map((value, index) => {
                                    return (<>
                                        <div className='sec2_div mt-4'>
                                            <div className='d-flex gap-2 align-items-center'>
                                                <img src={value.img} />
                                                <p className='analytic_text'>{value.text1}</p>
                                            </div>
                                            <div className='d-flex gap-2 justify-content-end align-items-center'>
                                                <img src={value.img2} />
                                                <p className='total2'>{value.text2}</p>

                                            </div>

                                        </div>




                                    </>)
                                })
                            }

                        </div>
                        <div className='col-lg-6 col-md-12 col-sm-12'>
                            <div className='d-flex gap-1 justify-content-center align-items-center analytic_main'>
                                <img src={fb} />
                                <p className='grid3_text'>Account Analysis</p>
                            </div>
                            <div className='chart_div'>
                                <div className='d-flex gap-3 justify-content-between align-items-center flex-wrap'>
                                    <div >
                                        <div className='d-flex gap-1 align-items-center'>
                                            <div className='color1'></div>
                                            <p className='color_text1'>Avg Likes</p>
                                        </div>
                                        <div className='d-flex gap-1 align-items-center'>
                                            <div className='color2'></div>
                                            <p className='color_text1'>Avg Views</p>
                                        </div>
                                        <div className='d-flex gap-1 align-items-center'>
                                            <div className='color3'></div>
                                            <p className='color_text1'>Avg Comments</p>
                                        </div>
                                    </div>
                                    <div>
                                        <button className='month_btn'>
                                            <div className='d-flex align-items-center gap-3'>
                                                <p className='months'>Months</p>
                                                <img src={down} />
                                            </div>
                                        </button>
                                    </div>
                                </div>
                                <img style={{ width: "100%", marginTop: "30px" }} src={chart} />
                            </div>

                        </div>
                    </div>




                </div>

            </div>
        </div>





    </>

    )
}

export default Analytics